// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"767dda13","279":"3e407598","667":"2c3484a4","843":"0f536643"}[chunkId] + ".chunk.js";
};